import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { User } from './User';
import { environment } from './../environments/environment';

// Initialize JwtHelperService instance
const helper = new JwtHelperService();

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) { }

  public getToken(): string | null {
    return localStorage.getItem('access_token');
  }

  public readToken(): any {
    const token = this.getToken();
    return token ? helper.decodeToken(token) : null;
  }

  isAuthenticated(): boolean {
    const token = this.getToken();

    // Check if the token exists and is not expired
    return token ? !helper.isTokenExpired(token) : false;
  }

  login(user: User): Observable<any> {
    const loginCredentials = {
      userName: user.userName,
      password: user.password
    };
    console.log('Sending login request to (v3 - relative):', `${environment.userAPIBase}/login`);
    return this.http.post<any>(`${environment.userAPIBase}/login`, loginCredentials).pipe(
      catchError(error => {
        console.error('Login error', error);
        return throwError(() => error);
      })
    );
  }

  logout(): void {
    localStorage.removeItem('access_token');
  }

  register(registerUser: User): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this.http.post<any>(
      `${environment.userAPIBase}/register`,
      registerUser,
      httpOptions
    ).pipe(
      catchError(error => {
        console.error('Registration error', error);
        return throwError(() => error);
      })
    );
  }
}
